module.exports = __webpack_public_path__ + "static/story-8aae3c21e7307af1853b318f7a9f44e2.gif";